export default "__VITE_ASSET__CMTuaLkC__"